const JsIcon = 'https://img.icons8.com/color/48/javascript--v2.png'
const ReactIcon = 'https://img.icons8.com/color/48/react-native.png'
const PythonIcon = 'https://img.icons8.com/color/48/python--v1.png'
const OpenCVIcon = 'https://img.icons8.com/color/48/opencv.png'
const PyTorchIcon = 'https://img.icons8.com/fluency/48/pytorch.png'
const TensorflowIcon = 'https://img.icons8.com/color/48/tensorflow.png'
const CIcon = 'https://img.icons8.com/color/48/c-programming.png'
const CppIcon = 'https://img.icons8.com/color/48/c-plus-plus-logo.png'
const GTMIcon = 'https://img.icons8.com/color/48/google-tag-manager.png'
const GAIcon = 'https://img.icons8.com/color/48/google-analytics.png'
const VueIcon = 'https://img.icons8.com/color/48/vue-js.png'
const NodeIcon = 'https://img.icons8.com/color/48/nodejs.png'
const MongoDBIcon = 'https://img.icons8.com/color/48/mongodb.png'
const ExpressIcon = 'https://img.icons8.com/color/48/express-js.png'
const MLIcon = 'https://img.icons8.com/pastel-glyph/64/brain-3--v1.png'
const RIcon = 'https://img.icons8.com/bubbles/50/r--v2.png'
const sqlIcon = 'https://img.icons8.com/color/48/my-sql.png'
const PGSQLIcon = 'https://img.icons8.com/color/48/postgreesql.png'

const skills = [
    { name: 'Python', icon: PythonIcon },
    { name: 'ML', icon: MLIcon },
    { name: 'OpenCV', icon: OpenCVIcon },
    { name:'PyTorch', icon: PyTorchIcon },
    { name: 'TensorFlow', icon: TensorflowIcon },
    { name: 'JavaScript', icon: JsIcon },
    { name: 'React', icon: ReactIcon },
    { name: 'Vue.js', icon: VueIcon },
    { name: 'Node.js', icon: NodeIcon },
    { name: 'C', icon: CIcon },
    { name: 'C++', icon: CppIcon },
    { name: 'MongoDB', icon: MongoDBIcon },
    { name: 'Express.js', icon: ExpressIcon },
    { name: 'Google Analytics', icon: GAIcon },
    { name: 'GTM', icon: GTMIcon },
    { name: 'R', icon: RIcon },
    { name: 'SQL', icon: sqlIcon },
    { name: 'PostgreSQL', icon: PGSQLIcon },
]

export default skills
